var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoga({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.998,
    height: 25.256,
    viewBox: "0 0 24.998 25.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_yoga_81539",
    transform: "translate(-4.999 -11.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M5.007,22.714c.06-.293.424-.447.829-.351,0,0,5.041,1.246,5.162,1.355,0,0,4.877.008,4.932.021a9.225,9.225,0,0,0,3.276,0S23.842,22.7,23.861,22.7c.136-.132,5.339-.825,5.339-.825.411-.049.76.147.795.445s-.242.58-.635.67c0,0-5.074,1.25-5.2,1.3L20.127,25.85a22.62,22.62,0,0,1,1.23,7.144l5.414.346a1.222,1.222,0,0,1,1.022,1.478,55.327,55.327,0,0,0,.615,7.4.931.931,0,0,1-.715,1.058.769.769,0,0,1-.872-.728l-.77-6.354H20.66c-.118,0-3.07.035-3.211.121l-5.743,3.47c-.062.038-4.755,3.669-4.755,3.669a.78.78,0,0,1-.792.115,1,1,0,0,1-.1-1.643s4.457-4.049,4.631-4.184c0,0,5.263-4.048,5.376-4.067,1.06-1.86.719-4.093-.281-7.6-.071.01-4.921-.722-4.921-.722-.179-.028-5.28-1.895-5.28-1.895C5.2,23.32,4.95,23,5.007,22.714Z",
    transform: "translate(0 -7.267)",
    fill: "#259a88"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 2.172,
    cy: 2.172,
    r: 2.172,
    transform: "translate(15.892 11.106)",
    fill: "#259a88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.697cc654b014bb68b0a60e3734b2e2c6.svg";
export { ForwardRef as ReactComponent };